import { useContext, useState } from "react";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import { MdClose, MdKeyboardArrowDown } from "react-icons/md";

export default function SideBar() {
  const appContext = useContext(AppContext);
  const [openGroup, setOpenGroup] = useState(null);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({ item });
    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  function goToSection(item, targetId) {
    appContext.navToSection(item, targetId);
    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  function goToSubItem(item, subItem) {
    appContext.navTo({
      item,
      subItem: subItem || undefined,
    });
    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  function toggleGroup(groupKey) {
    setOpenGroup((prev) => (prev === groupKey ? null : groupKey));
  }

  const groupedMenu = [
    {
      key: "about_us",
      label: "About Us",
      subItems: [
        { label: "About Overview", targetId: "about-overview" },
        { label: "Our Values", subItem: "values" },
        { label: "Why Work with Us", subItem: "work-with-us" },
      ],
    },
    {
      key: "products",
      label: "Products & Solutions",
      subItems: [
        { label: "Solutions Overview", subItem: null },
        { label: "Light Gauge Steel", subItem: "light-gauge-steel" },
        { label: "Waterproofing Solutions", subItem: "waterproofing-solutions" },
        { label: "Terrazzo Flooring", subItem: "terrazzo-flooring" },
        { label: "Additional Services", subItem: "additional-services" },
      ],
    },
    {
      key: "projects",
      label: "Our Experience",
      subItems: [
        { label: "Project Gallery", subItem: "gallery" },
      ],
    },
  ];

  return (
    <div className="SideBar sidebar-modern" data-open={appContext.isSideBarOpen}>
      <div className="body mNoScrollBar">
        <div className="sidebar-modern-head">
          <img src={logo} alt="Group V logo" className="sidebar-modern-logo" onClick={() => goTo("home")} />
          <button className="sidebar-modern-close" onClick={appContext.closeSideBar}>
            <MdClose size={22} />
          </button>
        </div>


        <button
          className={`sidebar-modern-pill text-muted ${!appContext.navItem || appContext.navItem === "home" ? "is-active" : ""}`}
          onClick={() => goTo("home")}
        >
          Home
        </button>

        {groupedMenu.map((group) => (
          <div key={group.key} className="side-group-wrap">
            <div className={`sidebar-modern-pill side-group-pill text-muted ${appContext.navItem === group.key ? "is-active" : ""}`}>
              <button className="side-group-label" onClick={() => goTo(group.key)}>
                {group.label}
              </button>
              <button className="side-group-arrow-wrap" onClick={() => toggleGroup(group.key)}>
                <MdKeyboardArrowDown size={20} className="side-group-arrow" data-open={openGroup === group.key} />
              </button>
            </div>

            <div className={`side-submenu ${openGroup === group.key ? "is-open" : ""}`}>
              {group.subItems.map((sub) => (
                <button
                  key={sub.subItem || sub.targetId || sub.label}
                  className="side-submenu-item text-muted"
                  onClick={() =>
                    sub.targetId
                      ? goToSection(group.key, sub.targetId)
                      : goToSubItem(group.key, sub.subItem)
                  }
                >
                  {sub.label}
                </button>
              ))}
            </div>
          </div>
        ))}

        <button
          className={`sidebar-modern-pill text-muted ${appContext.navItem === "contact_us" ? "is-active" : ""}`}
          onClick={() => goTo("contact_us")}
        >
          Contact Us
        </button>

        <style>{`
          .sidebar-modern {
            width: var(--sideBarWidth);
            z-index: var(--higherIndex);
          }

          .sidebar-modern > .body {
            background: #ffffff;
            border-right: 1px solid rgba(0, 0, 0, 0.08);
            padding: 14px;
          }

          .sidebar-modern-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border: 1px solid rgba(0, 0, 0, 0.08);
            border-radius: 12px;
            background: #ffffff;
            box-shadow: var(--shadow1);
            padding: 10px 12px;
            margin-bottom: 12px;
          }

          .sidebar-modern-logo {
            width: 145px;
            height: auto;
            cursor: pointer;
          }

          .sidebar-modern-close {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            border: 1px solid rgba(0, 0, 0, 0.12);
            background: #ffffff;
            color: var(--onSurfaceColor);
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }

          .sidebar-modern-close:hover {
            background: #f5f7fa;
          }

          .sidebar-modern-section-title {
            font-size: 11px;
            letter-spacing: 1px;
            text-transform: uppercase;
            color: #5f6e7a;
            margin-bottom: 8px;
            padding-left: 4px;
          }

          .sidebar-modern-pill {
            width: 100%;
            min-height: 44px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            background: #ffffff;
            padding: 10px 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            font-family: "FontSemiBold";
            color: var(--onSurfaceColor);
            margin-bottom: 6px;
            transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
          }

          .sidebar-modern-pill:hover,
          .sidebar-modern-pill.is-active {
            background: #eef5fb;
            border-color: #d5e6f6;
            color: var(--primaryColor);
          }

          .side-group-wrap {
            margin-bottom: 2px;
          }

          .side-group-pill {
            margin-bottom: 0;
          }

          .side-group-label,
          .side-group-arrow-wrap {
            border: none;
            background: transparent;
            color: inherit;
            font: inherit;
            padding: 0;
          }

          .side-group-label:focus-visible,
          .side-group-arrow-wrap:focus-visible,
          .side-submenu-item:focus-visible {
            outline: 2px solid #9fc0df;
            outline-offset: 2px;
          }

          .side-group-label {
            text-align: left;
            flex: 1;
          }

          .side-group-arrow-wrap {
            width: 24px;
            height: 24px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }

          .side-group-arrow {
            transition: transform 0.2s ease;
          }

          .side-group-arrow[data-open='true'] {
            transform: rotate(180deg);
          }

          .side-submenu {
            margin-left: 10px;
            margin-right: 2px;
            border-left: 2px solid rgba(129, 167, 200, 0.35);
            border-radius: 0 10px 10px 0;
            background: linear-gradient(180deg, rgba(240, 247, 253, 0.62), rgba(245, 250, 255, 0.38));
            padding: 0 6px 0 10px;
            max-height: 0;
            overflow: hidden;
            opacity: 0;
            transform: translateY(-2px);
            transition: max-height 0.28s ease, opacity 0.25s ease, transform 0.25s ease;
          }

          .side-submenu.is-open {
            max-height: 270px;
            opacity: 1;
            transform: translateY(0);
            margin-top: 6px;
            margin-bottom: 6px;
            padding-top: 7px;
            padding-bottom: 7px;
          }

          .side-submenu-item {
            width: 100%;
            border: 1px solid transparent;
            background: transparent;
            text-align: left;
            font-size: 13px;
            font-family: "FontSemiBold";
            color: #2f3e4d;
            padding: 8px 10px;
            border-radius: 8px;
            margin-bottom: 2px;
            display: flex;
            align-items: center;
            gap: 8px;
            transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
          }

          .side-submenu-item::before {
            content: "";
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #bdd3e7;
            transition: transform 0.2s ease, background 0.2s ease;
          }

          .side-submenu-item:hover {
            background: #edf4fb;
            border-color: #d5e4f2;
            color: var(--onSurfaceColor);
            transform: translateX(2px);
          }

          .side-submenu-item:hover::before {
            transform: scale(1.15);
            background: #80a9d2;
          }
        `}</style>
      </div>
    </div>
  );
}
